import { useMemo } from "react";
import { slugify } from "./slugify";

export interface Heading {
  id: string;
  text: string;
  level: 2 | 3;
}

/**
 * Extrahiert H2/H3-Überschriften aus Markdown-Quelltext für ein TOC.
 * Ignoriert Headings innerhalb von Code-Fences.
 */
export function useHeadings(markdown: string | null | undefined): Heading[] {
  return useMemo(() => {
    if (!markdown) return [];
    const lines = markdown.split(/\r?\n/);
    const out: Heading[] = [];
    const seen = new Map<string, number>();
    let inFence = false;
    for (const raw of lines) {
      const line = raw.trimEnd();
      if (/^```/.test(line.trim())) {
        inFence = !inFence;
        continue;
      }
      if (inFence) continue;
      const m = /^(#{2,3})\s+(.+?)\s*#*\s*$/.exec(line);
      if (!m) continue;
      const level = m[1].length as 2 | 3;
      const text = m[2].replace(/`/g, "").trim();
      let id = slugify(text);
      if (!id) continue;
      const n = seen.get(id) ?? 0;
      seen.set(id, n + 1);
      if (n > 0) id = `${id}-${n + 1}`;
      out.push({ id, text, level });
    }
    return out;
  }, [markdown]);
}
